// Erlaubte Statuswechsel eines Reisetermins
import { reiseterminStateFormatter } from '@/core/common/helpers/utils';

const STATUSWECHSEL = {
  Vorgeschlagen: { status: ['CmAngefragt'], verwerfen: 'immer' },
  CmAngefragt: {
    status: ['CmBestaetigt', 'CmAbgelehnt'],
    statusNurInBlank: ['Abgesagt'],
    verwerfen: 'nurNichtInBlank',
  },
  CmBestaetigt: {
    status: ['Anlagebereit', 'CmAngefragt'],
    statusNurInBlank: ['Aufgelegt'],
    verwerfen: 'nurNichtInBlank',
  },
  CmAbgelehnt: { status: ['CmAngefragt'], verwerfen: 'nurNichtInBlank' },
  Verworfen: { status: ['Vorgeschlagen'], verwerfen: 'nie' },
  Anlagebereit: { status: [], verwerfen: 'immer' },
  Durchfuehrung: { status: ['Abgesagt'], verwerfen: 'nie' },
  Durchgefuehrt: { status: ['Abgesagt'], verwerfen: 'nie' },
};

// Ein Termin gilt als in Blank angelegt, sobald er dort tatsächlich existiert
export function istInBlankAngelegt(reiseterminSyncState) {
  return (
    !!reiseterminSyncState &&
    reiseterminSyncState !== 'None' &&
    reiseterminSyncState !== 'NotAvailableInBlank'
  );
}

// Baut aus der Regel die Dropdown-Einträge
function buildOptionen(regel, inBlank, nichtInBlank) {
  const werte = [...regel.status, ...(inBlank ? regel.statusNurInBlank ?? [] : [])];
  return {
    statusOptionen: werte.map(value => {
      const text = reiseterminStateFormatter[value] ?? value;
      return { value, text, label: `Status auf "${text}"` };
    }),
    verwerfenErlaubt: regel.verwerfen === 'immer' || (regel.verwerfen === 'nurNichtInBlank' && nichtInBlank),
  };
}

// Liefert die Statuswechsel einer Mehrfachauswahl
export function getStatuswechselOptionenMehrfach(state, reiseterminSyncStates = []) {
  const regel = STATUSWECHSEL[state];
  if (!regel || !reiseterminSyncStates.length) {
    return { statusOptionen: [], verwerfenErlaubt: false };
  }
  return buildOptionen(
    regel,
    reiseterminSyncStates.every(istInBlankAngelegt),
    !reiseterminSyncStates.some(istInBlankAngelegt)
  );
}

// Liefert die Dropdown-Eintraege der Statuswechsel und ob "Termin verwerfen" angeboten wird
export function getStatuswechselOptionen(state, reiseterminSyncState) {
  return getStatuswechselOptionenMehrfach(state, [reiseterminSyncState]);
}
